/* Collection grids (all collections):
   1) Hide sold-out products completely (never reveal them).
   2) Sort remaining cards so products with the most images sit at the top.
   Works with load-more / infinite scroll: each new batch is filtered, then
   the full visible grid is re-sorted by imageCount. */
(function () {
  var GRID_SELECTOR = '.t4s-main-collection-page .t4s_box_pr_grid, .t4s-main-collection-page .t4s_box_pr_masonry';
  var ITEM_SELECTOR = '.t4s-product';
  /* Prefer the next-page sentinel. Never click data-is-prev. */
  var LOAD_MORE_SELECTOR = '[data-load-onscroll], [data-wrap-lm] [data-load-more]:not([data-is-prev])';
  var AUTO_CHAIN_DELAY_MS = 400;
  var MAX_AUTO_CHAIN = 40;

  function parseOptions(item) {
    var raw = item.getAttribute('data-product-options');
    if (!raw) return null;
    try {
      return JSON.parse(raw);
    } catch (e) {
      return null;
    }
  }

  function isSoldOut(item) {
    var options = parseOptions(item);
    if (options && typeof options.available === 'boolean') {
      return options.available === false;
    }
    return !!item.querySelector('[data-badge-soldout]');
  }

  function imageCount(item) {
    var options = parseOptions(item);
    if (options && typeof options.imageCount === 'number') {
      return options.imageCount;
    }
    var imgs = item.querySelectorAll('img');
    return imgs ? imgs.length : 0;
  }

  function getLoadMoreTrigger() {
    return document.querySelector(LOAD_MORE_SELECTOR);
  }

  function initGrid(grid) {
    if (grid.__soldOutFilterInit) return;
    grid.__soldOutFilterInit = true;

    var autoChainCount = 0;
    var observer;

    function sortByMostImages() {
      var items = Array.prototype.slice.call(grid.querySelectorAll(':scope > ' + ITEM_SELECTOR));
      if (items.length < 2) return;
      var sorted = items.slice().sort(function (a, b) {
        var diff = imageCount(b) - imageCount(a);
        if (diff !== 0) return diff;
        return 0;
      });
      var alreadySorted = sorted.every(function (item, i) {
        return item === items[i];
      });
      if (alreadySorted) return;
      if (observer) observer.disconnect();
      var frag = document.createDocumentFragment();
      sorted.forEach(function (item) {
        frag.appendChild(item);
      });
      grid.appendChild(frag);
      if (observer) observer.observe(grid, { childList: true });
    }

    function filterSoldOut(items) {
      var newlyVisible = 0;
      items.forEach(function (item) {
        if (isSoldOut(item)) {
          item.remove();
        } else {
          newlyVisible += 1;
        }
      });
      return newlyVisible;
    }

    function maybeAutoChain(newlyVisible) {
      var trigger = getLoadMoreTrigger();
      if (!trigger) return;
      if (newlyVisible === 0 && autoChainCount < MAX_AUTO_CHAIN) {
        autoChainCount += 1;
        setTimeout(function () {
          var nextTrigger = getLoadMoreTrigger();
          if (nextTrigger) nextTrigger.click();
        }, AUTO_CHAIN_DELAY_MS);
      }
    }

    var initialItems = Array.prototype.slice.call(grid.querySelectorAll(':scope > ' + ITEM_SELECTOR));
    var initialVisible = filterSoldOut(initialItems);
    sortByMostImages();
    maybeAutoChain(initialVisible);

    observer = new MutationObserver(function (mutations) {
      var addedItems = [];
      mutations.forEach(function (mutation) {
        Array.prototype.forEach.call(mutation.addedNodes, function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches(ITEM_SELECTOR)) {
            addedItems.push(node);
          } else if (node.querySelectorAll) {
            addedItems.push.apply(
              addedItems,
              Array.prototype.slice.call(node.querySelectorAll(ITEM_SELECTOR))
            );
          }
        });
      });
      if (!addedItems.length) return;
      var newlyVisible = filterSoldOut(addedItems);
      sortByMostImages();
      maybeAutoChain(newlyVisible);
    });

    observer.observe(grid, { childList: true });
  }

  function init() {
    document.querySelectorAll(GRID_SELECTOR).forEach(initGrid);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
